module.exports = __webpack_public_path__ + "static_pc/img/fond01.c4c92100.png";